var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"y-back"},[_c('div',{staticClass:"return",on:{"click":_vm.handleBackUrl}},[_c('i',{staticClass:"iconfont icon-fanhui"}),_vm._t("default",function(){return [_vm._v("返回上一步")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }